import { AfterContentInit, Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DeliveryDto } from "../../../core/dto/delivery.dto";
import { UserDto } from "../../../core/dto/user.dto";
import { NavControllerExtended } from "../../../gyzmo-commons/helpers/navControllerExtended";
import { isNullOrEmpty } from "../../../gyzmo-commons/helpers/null.helper";
import { BackEndDatePipe } from "../../../gyzmo-commons/helpers/pipes/backEndDate.pipe";
import { BackEndHourPipe } from "../../../gyzmo-commons/helpers/pipes/backEndHour.pipe";

@Component({
    selector: "delivery-card",
    templateUrl: "delivery-card.component.html",
    styleUrls: ["delivery-card.component.scss"],
})
export class DeliveryCardComponent implements AfterContentInit {
    @Input() delivery: DeliveryDto;
    @Input() user: UserDto;
    @Input() cardFields: string[];
    @Input() mine: boolean;

    cardFieldsLines: string[][];

    constructor(public navCtrl: NavControllerExtended,
                public translateService: TranslateService) {
    }

    public ngAfterContentInit(): void {
        if (!this.cardFields) {
            return;
        }

        this.cardFieldsLines = [];
        for (let i = 0; i < this.cardFields.length; i = i + 2) {
            let line = [];
            line.push(this.cardFields[i]);
            if (this.cardFields[i + 1]) {
                line.push(this.cardFields[i + 1]);
            }

            this.cardFieldsLines.push(line);
        }
    }

    getLinesCount() {
        return this.delivery.linkedMovements.length;
    }

    getLinesButtonColor() {
        if (this.mine) {
            return "first-category";
        } else {
            return "third-category";
        }
    }

    public getFieldValue(cardField: string) {
        try {
            if (isNullOrEmpty(cardField)) {
                return "";
            }
            cardField = cardField.trim();

            if (cardField.startsWith("\"")) {
                return cardField.substring(1, cardField.length - 1);
            } else if (cardField.startsWith("$")) {
                switch (cardField) {
                    case "$EQUIPMENT_ID":
                        return this.delivery.equipment.id;
                    case "$EQUIPMENT_WORDING":
                        return this.delivery.equipment.title.toUpperCase();
                    case "$REGISTRATION_NUMBER":
                        return this.delivery.equipment.registrationNumber.toUpperCase();
                    case "$MOVEMENT_KIND":
                        return this.delivery.movement.relatedTable;
                    case "$MOVEMENT_KEY":
                        return this.delivery.movement.documentNumber;
                    case "$START_DATE":
                        return new BackEndDatePipe().transform(this.delivery.startDate);
                    case "$START_HOUR":
                        return new BackEndHourPipe().transform(this.delivery.startDate);
                    case "$PLANNED_RETURN_DATE":
                        return new BackEndDatePipe().transform(this.delivery.plannedReturnDate);
                    case "$PLANNED_RETURN_HOUR":
                        return new BackEndHourPipe().transform(this.delivery.plannedReturnDate);
                    case "$CUSTOMER_NAME":
                        return this.delivery.movement.customer.firstName.toUpperCase() + " " + this.delivery.movement.customer.lastName;
                    case "$DRIVER_NAME":
                        return this.delivery.driver.firstName.toUpperCase() + " " + this.delivery.driver.lastName;
                    default:
                        return "Unknown Token (" + cardField + ")";
                }
            }

            return "Unknown Token (" + cardField + ")";
        } catch (e) {
            return "";
        }
    }

    public getFieldLabel(cardField: string) {
        try {
            if (isNullOrEmpty(cardField)) {
                return "";
            }
            cardField = cardField.trim();

            if (cardField.startsWith("\"")) {
                return "";
            } else if (cardField.startsWith("$")) {
                switch (cardField) {
                    case "$START_DATE":
                        return this.translateService.instant("IMCP_StartDate:");
                    case "$START_HOUR":
                        return this.translateService.instant("IMCP_StartHour:");
                    case "$PLANNED_RETURN_DATE":
                        return this.translateService.instant("IMCP_PlannedReturnDate:");
                    case "$PLANNED_RETURN_HOUR":
                        return this.translateService.instant("IMCP_PlannedReturnHour:");

                    case "$EQUIPMENT_ID":
                        return this.translateService.instant("IMCP_EquipmentId:");
                    case "$EQUIPMENT_WORDING":
                        return this.translateService.instant("IMCP_Equipment:");
                    case "$REGISTRATION_NUMBER":
                        return this.translateService.instant("IMCP_RegistrationNumber:");
                    case "$CONTRACT_NUMBER":
                        return this.translateService.instant("IMCP_Contract_number:");
                    case "$BOOKING_CODE":
                        return this.translateService.instant("IMCP_Booking_code_:");
                    case "$MOVEMENT_DATE":
                    case "$MOVEMENT_DAY":
                    case "$INSPECTION_MOVEMENT_DAY":
                        return this.translateService.instant("IMCP_Date:");
                    case "$MOVEMENT_HOUR":
                    case "$INSPECTION_MOVEMENT_HOUR":
                        return this.translateService.instant("IMCP_Hour:");
                    case "$CUSTOMER_NAME":
                        return this.translateService.instant("IMCP_Customer:");
                    case "$CATEGORY_WORDING":
                        return this.translateService.instant("IMCP_Category:");
                    case "$AGENCY":
                        return this.translateService.instant("IMCP_Agency:");
                    case "$CONTRACT_AMOUNT":
                        return this.translateService.instant("IMCP_ContractAmount:");

                    case "$MOVEMENT_KIND":
                        return this.translateService.instant("IMCP_MovementKind:");
                    case "$MOVEMENT_KEY":
                        return this.translateService.instant("IMCP_MovementKey:");
                    case "$DRIVER_NAME":
                        return this.translateService.instant("IMCP_DriverName:");
                    case "$INSPECTION_DATE_HOUR":
                    case "$INSPECTION_DAY":
                        return this.translateService.instant("IMCP_InspectionDate:");
                    case "$INSPECTION_HOUR":
                        return this.translateService.instant("IMCP_InspectionHour:");
                    default:
                        return cardField;
                }
            }

            return cardField;
        } catch (e) {
            return cardField;
        }
    }
}
